var map = {
	"./white/0.25.svg": 796,
	"./white/0.5.svg": 797,
	"./white/0.75.svg": 798,
	"./white/0.svg": 799,
	"./white/1.svg": 800,
	"./white/10.svg": 801,
	"./white/11.svg": 802,
	"./white/2.svg": 803,
	"./white/3.svg": 804,
	"./white/4.svg": 805,
	"./white/5.svg": 806,
	"./white/6.svg": 807,
	"./white/7.svg": 808,
	"./white/8.svg": 809,
	"./white/9.svg": 810,
	"./yellow/0.25.svg": 811,
	"./yellow/0.5.svg": 812,
	"./yellow/0.75.svg": 813,
	"./yellow/0.svg": 814,
	"./yellow/1.svg": 815,
	"./yellow/10.svg": 816,
	"./yellow/11.svg": 817,
	"./yellow/2.svg": 818,
	"./yellow/3.svg": 819,
	"./yellow/4.svg": 820,
	"./yellow/5.svg": 821,
	"./yellow/6.svg": 822,
	"./yellow/7.svg": 823,
	"./yellow/8.svg": 824,
	"./yellow/9.svg": 825
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 795;